import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __stringify } from '@nu-art/ts-common';
import { ModuleFE_Account } from '../_entity/account/index.js';
import { ComponentSync, LL_V_L, TS_Input, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
export class ATS_SessionData extends ComponentSync {
    static screen = { name: `SessionData`, renderer: this, group: 'Permissions' };
    static defaultProps = {
        modules: [],
        pageTitle: () => this.screen.name
    };
    deriveStateFromProps(nextProps, state) {
        state = this.state ?? {};
        return state;
    }
    constructor(p) {
        super(p);
    }
    async __onStorageKeyEvent(event) {
        this.forceUpdate();
    }
    getDecodedSessionId() {
        try {
            if (this.state.sessionId && this.state.sessionId.length) { // @ts-ignore
                return __stringify(ModuleFE_Account.decode(this.state.sessionId), true);
            }
            // @ts-ignore
            return __stringify(ModuleFE_Account.sessionData, true);
        }
        catch (e) {
            // @ts-ignore
            return __stringify(ModuleFE_Account.sessionData, true);
        }
    }
    render() {
        const sessionDataAsJson = this.getDecodedSessionId();
        return _jsxs(LL_V_L, { className: 'match_parent', children: [_jsx(TS_Input, { type: 'text', onBlur: (value) => {
                        this.setState({ sessionId: value });
                    } }), _jsx(TS_TextArea, { style: { fontFamily: 'monospace', fontSize: 15 }, type: "text", value: sessionDataAsJson, disabled: true })] });
    }
}
//# sourceMappingURL=ATS_SessionData.js.map